import { adminRolesWithUser, apAccessRolesWithRefman } from "services/user/type"

/**
 * Pretty-print a built-in role id ("SUPPORT_PLUS" → "Support Plus") for
 * display. Custom roles already have a human-readable `name`; don't run them
 * through this helper.
 */
export const formatRoleName = (role: string): string =>
  role
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase())

export const adminRoles = apAccessRolesWithRefman.map((role) => ({
  name: formatRoleName(role),
  value: role
}))

export const allRolesFormatted = adminRolesWithUser.map((role) => ({
  name: formatRoleName(role),
  value: role
}))
